const PerformanceMetrics = {
  name: 'PerformanceMetrics',
  type: 'object',
  properties: {
    Impressions: {
      type: 'integer',
      nullable: true,
    },
    Clicks: {
      type: 'integer',
      nullable: true,
    },
    CTR: {
      type: 'number',
      nullable: true,
    },
    Conversions: {
      type: 'integer',
      nullable: true,
    },
    Spend: {
      type: 'number',
      nullable: true,
    },
    AverageCPC: {
      type: 'number',
      nullable: true,
    },
    AveragePosition: {
      type: 'number',
      nullable: true,
    },
    AverageCPM: {
      type: 'number',
      nullable: true,
    },
    CPA: {
      type: 'number',
      nullable: true,
    },
    WebsiteCoverage: {
      type: 'number',
      nullable: true,
    },
    AuctionWonPercent: {
      type: 'number',
      nullable: true,
      sovcolumn: true,
      isPercentValue: true,
    },
    AuctionLostToBudgetPercent: {
      type: 'number',
      nullable: true,
      sovcolumn: true,
      isPercentValue: true,
    },
    AuctionLostToRankPercent: {
      type: 'number',
      nullable: true,
      sovcolumn: true,
      isPercentValue: true,
    },
    AuctionLostToLandingPercent: {
      type: 'number',
      nullable: true,
      sovcolumn: true,
      isPercentValue: true,
    },
    AuctionLostToAdQualityPercent: {
      type: 'number',
      nullable: true,
      sovcolumn: true,
      isPercentValue: true,
    },
    AuctionLostToBidPercent: {
      type: 'number',
      nullable: true,
      sovcolumn: true,
      isPercentValue: true,
    },
    ClickSharePercent: {
      type: 'number',
      nullable: true,
    },
    RevenueOnAdSpend: {
      type: 'number',
      nullable: true,
    },
    AdvertiserReportedRevenue: {
      type: 'number',
      nullable: true,
    },
    ConversionRate: {
      type: 'number',
      nullable: true,
    },
    AllConversionCPA: {
      type: 'number',
      nullabe: true,
    },
    AllConversions: {
      type: 'integer',
      nullabe: true,
    },
    AllConversionRate: {
      type: 'number',
      nullabe: true,
    },
    AllConversionAdvertiserReportedRevenue: {
      type: 'number',
      nullabe: true,
    },
    AllConversionRevenueOnAdSpend: {
      type: 'number',
      nullabe: true,
    },
  },
};

const Labels = {
  type: 'array',
  items: {
    type: 'object',
    schema: {
      name: 'Label',
      type: 'object',
      key: 'Id',
      properties: {
        Id: {
          type: 'integer',
          key: true,
          nullable: true,
        },
        Name: {
          type: 'string',
          maxLength: 80,
          required: true,
        },
        Description: {
          type: 'string',
          maxLength: 200,
        },
        ColorCode: {
          type: 'integer',
          nullable: true,
        },
        AssociationCounts: {
          type: 'object',
          schema: {
            name: 'LabelAssociationCounts',
            type: 'object',
            properties: {
              CampaignCount: {
                type: 'integer',
              },
              AdGroupCount: {
                type: 'integer',
              },
              AdCount: {
                type: 'integer',
              },
              KeywordCount: {
                type: 'integer',
              },
            },
          },
        },
      },
    },
  },
  isRelatedEntity: true,
  filterable: true,
};

export const mockSchema = {
  name: 'AdGroup',
  type: 'object',
  key: 'Id',
  required: ['Name'],
  properties: {
    Id: {
      type: 'integer',
      key: true,
    },
    Name: {
      type: 'string',
      filterable: true,
      maxLength: 256,
    },
    Campaign: {
      type: 'object',
      filterable: ['Name'],
      schema: {
        key: 'Id',
        name: 'Campaign',
        type: 'object',
        properties: {
          Name: {
            type: 'string',
            filterable: true,
          },
        },
      },
    },
    StartDate: {
      type: 'datetime',
      filterable: true,
    },
    EndDate: {
      type: 'datetime',
      nullable: true,
      filterable: true,
    },
    Status: {
      type: 'string',
      enum: ['CampaignUserPaused', 'CampaignBudgetPaused', 'CampaignBudgetUserPaused', 'Draft', 'Active', 'Deleted', 'Paused', 'Expired'],
      filterable: true,
      enumType: 'AdGroupStatus', // the one in our adsappsUI
    },
    SearchBid: {
      type: 'number',
      nullable: true,
      filterable: true,
    },
    ContentBid: {
      type: 'number',
      nullable: true,
      filterable: true,
    },
    PercentCpcBid: {
      schema: {
        properties: {
          RateAmount: {
            schema: {
              type: 'object',
              properties: {
                Amount: {
                  nullable: true,
                  oneOf: [
                    {
                      $ref: 'Edm/Double',
                      type: 'number',
                      name: 'Double',
                    },
                    {
                      type: 'null',
                    },
                  ],
                  type: 'number',
                  name: 'Double',
                },
              },
              $$ODataExtension: {
                Name: 'RateAmount',
              },
              name: 'RateAmount',
              $$ref: 'Model/RateAmount',
            },
            $ref: 'Model/RateAmount',
            type: 'object',
          },
        },
        type: 'object',
        $$ODataExtension: {
          Name: 'RateBid',
        },
        name: 'RateBid',
        $$ref: 'Model/RateBid',
      },
      $ref: 'Model/RateBid',
      type: 'object',
    },
    AdGroupPercentCpcBid: {
      nullable: true,
      oneOf: [
        {
          $ref: 'Edm/Double',
          type: 'number',
          name: 'Double',
        },
        {
          type: 'null',
        },
      ],
      type: 'number',
      name: 'Double',
      'bulk-upload-header': 'Percent Cpc Bid',
    },
    CommissionRate: {
      schema: {
        properties: {
          RateAmount: {
            schema: {
              type: 'object',
              properties: {
                Amount: {
                  nullable: true,
                  oneOf: [
                    {
                      $ref: 'Edm/Double',
                      type: 'number',
                      name: 'Double',
                    },
                    {
                      type: 'null',
                    },
                  ],
                  type: 'number',
                  name: 'Double',
                },
              },
              $$ODataExtension: {
                Name: 'RateAmount',
              },
              name: 'RateAmount',
              $$ref: 'Model/RateAmount',
            },
            $ref: 'Model/RateAmount',
            type: 'object',
          },
        },
        type: 'object',
        $$ODataExtension: {
          Name: 'RateBid',
        },
        name: 'RateBid',
        $$ref: 'Model/RateBid',
      },
      $ref: 'Model/RateBid',
      type: 'object',
    },
    AdGroupCommissionRate: {
      nullable: true,
      oneOf: [
        {
          $ref: 'Edm/Double',
          type: 'number',
          name: 'Double',
        },
        {
          type: 'null',
        },
      ],
      type: 'number',
      name: 'Double',
      'bulk-upload-header': 'Commission Rate',
    },
    Medium: {
      type: 'string',
      enum: ['Search', 'Content', 'SearchAndContent'],
    },
    PricingModel: {
      type: 'string',
      enum: ['CPC', 'CPM'],
    },
    Language: {
      type: 'string',
      enum: ['Arabic', 'TraditionalChinese', 'Danish', 'Dutch', 'English', 'Finnish', 'French', 'German', 'Italian', 'Norwegian', 'Portuguese', 'Spanish', 'Swedish', 'SimplifiedChinese', 'All'],
      nullable: true,
      chooseType: 'select',
      enumType: 'Language',
    },
    BidTarget: {
      type: 'string',
      enum: ['Keyword', 'BehaviorSegment', 'Site'],
    },
    DeliveryStatus: {
      type: 'string',
      enum: ['CreditCardExpired', 'IOExceeded', 'PaymentInformationMissing', 'InvalidFinancialStatusOther', 'MigrationPaused', 'CampaignDeleted', 'CampaignSuspended', 'CampaignBudgetPaused', 'DomainLanguageNotSupported', 'ShoppingCampaignStoreNotFound', 'ShoppingCampaignNoOffersPresent', 'AdGroupExpired', 'AdGroupDraft', 'AdGroupDeleted', 'CamAssetRejected', 'CamAssetDeleted', 'EditorialRejected', 'EditorialUnderAppeal', 'UrlInvalid', 'ApplicationNotFound', 'ApplicationDestinationUrlMismatch', 'PendingMetadataSync', 'EditorialPending', 'AssociationDeleted', 'CampaignUserPaused', 'AdGroupUserPaused', 'AdUserPaused', 'KeywordMatchTypeAdGroupMediumCombinationInvalid', 'KeywordUserPaused', 'NegativeKeywordConflicts', 'EditorialApprovedLimited', 'LowSupply', 'LowQuality', 'BidBelowFirstPageBid', 'Incomplete', 'BudgetSuggestions', 'InlineOpportunity', 'GeoCodingIncomplete', 'ProductTargetUserPaused', 'AdExtensionNotPresent', 'AdExtensionDeleted', 'AdExtensionAssociationDeleted', 'StoreIdNotAssociated', 'AdGroupAudienceAssociationPaused', 'AdGroupAudienceAssociationExcluded', 'AdNotPresent', 'AdNotActive', 'ApplicationDestinationUrlValidationIncomplete', 'Eligible'],
      filterable: true,
    },
    CallTrackingStatus: {
      type: 'string',
      enum: ['NotApplicable', 'Eligible', 'NotEligible', 'ProvisioningPending', 'Provisioned'],
    },
    PerformanceMetrics: {
      type: 'object',
      schema: PerformanceMetrics,
      filterable: ['Impressions', 'Clicks', 'CTR', 'Spend', 'Conversions',
        'AverageCPC', 'AverageCPM', 'AveragePosition', 'CPA', 'RevenueOnAdSpend',
        'ConversionRate', 'AdvertiserReportedRevenue', 'AllConversionCPA', 'AllConversions',
        'AllConversionRate', 'AllConversionAdvertiserReportedRevenue', 'AllConversionRevenueOnAdSpend'],
      alias: {
        Spend: {
          legacy: 'TotalEffectiveCost',
        },
      },
    },
    Labels,
    PhonePerformanceMetrics: {
      type: 'object',
      $schema: {},
    },
    QualityScore: {
      type: 'object',
      $schema: {},
    },
    UpdatedOnLastImport: {
      type: 'boolean',
    },
    HasAuctionInsight: {
      type: 'boolean',
      filterable: true,
    },
    IsBidLandscapeAvailable: {
      type: 'boolean',
    },
    TrackingUrlTemplate: {
      type: 'string',
    },
    UrlCustomParameters: {
      type: 'array',
      items: {
        type: 'object',
        $schema: {},
      },
    },
    BiddingScheme: {
      type: 'object',
      $schema: {},
    },
    NativeBidAdjustment: {
      type: 'integer',
      nullable: true,
    },
    Properties: {
      type: 'array',
      items: {
        type: 'object',
      },
    },
    DisplayBiddingStrategyType: {
      type: 'string',
      enum: ['InheritFromParent', 'ManualCpc', 'MaxClicks', 'MaxConversions', 'TargetCpa', 'EnhancedCpc'],
    },
    DisplayBiddingStrategyMaxCpc: {
      type: 'number',
      nullable: true,
    },
    DisplayBiddingStrategyTargetCpa: {
      type: 'number',
      nullable: true,
    },
    DsaTargets: {
      type: 'array',
      items: {
        type: 'object',
        $schema: {},
      },
    },
    DomainCategorys: {
      type: 'array',
      items: {
        type: 'object',
        $schema: {},
      },
    },
    NegativeAdGroupDsaTargets: {
      type: 'array',
      items: {
        type: 'object',
        $schema: {},
      },
    },
    Categories: {
      type: 'array',
      items: {
        type: 'object',
        $schema: {},
      },
    },
    DsaSearchTerms: {
      type: 'array',
      items: {
        type: 'object',
        $schema: {},
      },
    },
  },
};
